import React from 'react';
import { Loader2 } from 'lucide-react';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary' | 'outline' | 'ghost';
  size?: 'sm' | 'md' | 'lg';
  isLoading?: boolean;
}
export function Button({
  children,
  className = '',
  variant = 'primary',
  size = 'md',
  isLoading = false,
  disabled,
  ...props
}: ButtonProps) {
  const baseStyles = 'inline-flex items-center justify-center font-bold uppercase tracking-wider transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-offset-2 disabled:opacity-50 disabled:pointer-events-none';
  const variants = {
    primary: 'bg-[#175445] text-[#fbf7dd] hover:bg-[#123B35] focus:ring-[#175445]',
    secondary: 'bg-[#FFC107] text-black hover:bg-[#e0a800] focus:ring-[#FFC107]',
    outline: 'border-2 border-white text-[#fbf7dd] hover:bg-white/10 focus:ring-white',
    ghost: 'bg-transparent text-gray-700 hover:bg-gray-100 hover:text-gray-900'
  };
  const sizes = {
    sm: 'h-8 px-3 text-xs',
    md: 'h-10 px-6 text-sm',
    lg: 'h-14 px-8 text-base'
  };
  return <button className={`${baseStyles} ${variants[variant]} ${sizes[size]} ${className}`} disabled={disabled || isLoading} {...props} data-id="element-464">
      {isLoading && <Loader2 className="mr-2 h-4 w-4 animate-spin" data-id="element-465" />}
      {children}
    </button>;
}